import { render, staticRenderFns } from "./partnerDeduct.vue?vue&type=template&id=09311e28&"
import script from "./partnerDeduct.vue?vue&type=script&lang=js&"
export * from "./partnerDeduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports